import * as React from 'react';
import { SigninNavigationContext, SigninNavigationContextProps } from '../hoc/SigninNavigationContext';

export const useSigninNavigation = (): SigninNavigationContextProps => {
    const signinNavigation = React.useContext(SigninNavigationContext);
    if (!signinNavigation) {
        throw new Error('Service is not registered yet');
    }

    return signinNavigation;
};
